import React, { memo } from "react";
import clsx from "clsx";
import styles from "./Upholstery.module.scss";
import Interior360 from "./interior-360/Interior360";
import InteriorSlider from "./interior-slider/InteriorSlider";
import { type ImageCarConfigOverrideType, useInteriorCarImages } from "../../../../hooks/useAphVisual";
import { useCarConfigSelector } from "../../../../redux/store";
import { SpinnerType } from "../../../../redux/slices/CarConfigSpinNavigationSlice";
import { show3dSpin } from "../../../../../../shared-logic/utils/imageUtils";

export type Props = {
    overrideCarConfig?: ImageCarConfigOverrideType; // When this is added, the carConfig from CCIS will be overridden with a custom config. Used for availableInOtherGrades.
    id?: string;
};

export const UPHOLSTERY_SPIN_ID = "or-upholstery-spin-wrapper";

const Upholstery: React.FC<Props> = ({ overrideCarConfig, ...rest }) => {
    const upholsterySpinIsActive = useCarConfigSelector(
        (state) => state.carConfigSpinNavigation.activeSpin === SpinnerType.Upholstery,
    );
    const upholsterySpinIsInitialized = useCarConfigSelector((state) => state.car.initialized);
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const car = useCarConfigSelector((state) => state.car);
    const enable3dSpin = show3dSpin(commonSettings, car.model.configVersion);

    const interiorImages = useInteriorCarImages(
        [3, 1, 5, 4, 0, 2],
        upholsterySpinIsActive,
        overrideCarConfig && {
            useAvailableInOtherGradeImages: {
                overrideCarImageInput: overrideCarConfig?.imageCarConfig,
                overrideCarIds: overrideCarConfig?.carIds,
            },
        },
    ).map(({ src }) => src);

    return (
        <figure
            className={clsx(
                enable3dSpin ? styles["upholstery-3d"] : styles["upholstery-slider"],
                upholsterySpinIsActive && styles.show,
            )}
            {...rest}
        >
            {upholsterySpinIsInitialized &&
                (enable3dSpin ? (
                    <Interior360
                        images={interiorImages}
                        className={styles["upholstery-image"]}
                        enabled={upholsterySpinIsActive}
                    />
                ) : (
                    <InteriorSlider fullHeight overrideCarConfig={overrideCarConfig} />
                ))}
        </figure>
    );
};

export default memo(Upholstery);
